export const IssueStatusValues = ['resolved', 'dismissed', 'open'] as const;
export type IssueStatus = typeof IssueStatusValues[number];

export enum ScanStatus {
  INIT = 'init',
  PENDING = 'pending',
  DONE = 'done',
}
export enum BestPracticeResourceCheckStatus {
  PENDING = 'pending',
  DONE = 'done',
}

export interface ActiveScan {
  status: ScanStatus;
  checkStatusCounts: Record<BestPracticeResourceCheckStatus, number>;
}

export interface Issue {
  id: string;
  resourceName: string;
  status: IssueStatus;

  bestPracticeId: string;
  resourceType: string;
  bestPracticeName: string;
  severity: IssueSeverity;

  description: string;
  createdAt: Date;
  isNew: boolean;
  isCleared: boolean;
}

export const IssueSeverityValues = ['Low', 'Medium', 'High'] as const;
export type IssueSeverity = typeof IssueSeverityValues[number];

export interface MonitoringV2PotentialIssuesResponse {
  issues: Issue[];
  activeScan?: ActiveScan;
}
